if (!customElements.get('content-cards-grid')) {
  customElements.define('content-cards-grid', class extends HTMLElement {
    constructor() {
      super();

      this.cardContentElementsArray = Array.from(this.querySelectorAll('.content-cards-item__content'));
    }

    connectedCallback() {
      this.setSimilarHeightOfCardContentElements();
    }

    setSimilarHeightOfCardContentElements() {
      const maxElementsHeight = Math.max(...this.cardContentElementsArray.map(el => el.offsetHeight));
      this.cardContentElementsArray.forEach(el => {
        el.style.minHeight = `${maxElementsHeight}px`;
      });
    }
  })
}